export enum RoutesPath {
  HOME = '/',
  LOGIN = '/login',
  USRES = '/users',
  WORK_ORDER = '/work-order',
  WORK_ORDER_NEW = '/work-order/:id',
  INVENTORY = '/inventory',
  INVENTORY_HISTORY = '/inventory-history/:id',
}
